import { AttendeesService } from './attendees-service';

let attendeesServiceInstance: AttendeesService | null = null;

const getAttendessService = (): AttendeesService => {
  if(attendeesServiceInstance === null) {
    attendeesServiceInstance = new AttendeesService();
  }

  return attendeesServiceInstance;
};

export { getAttendessService };